/**
 * Shared constants for the benchmarking PDF report.
 * Kept separate from pdfTokens.ts (design tokens) to avoid mixing concerns.
 */

/**
 * Ordered list of Elo face icon names used in the competency table header
 * and apontamentos section icons. Order matches competency levels worst→best.
 */
export const FACE_ICON_NAMES = [
  'face-hate-circle',
  'face-dislike-circle',
  'face-neutral-circle',
  'face-like-circle',
  'face-love-circle',
] as const;

export type FaceIconName = (typeof FACE_ICON_NAMES)[number];
